'use client'

import React, { useState } from 'react'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import { ClubhouseHeroSection, NewsBoardSection } from 'Components/Sections'
import { Column } from 'Components/UI'

function ClubhousePage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  return (
    <Column alignCenter fullWidth>
      <ClubhouseHeroSection onAction={() => setJoinUsModalModalOpened(true)} />

      <NewsBoardSection py={[10, 10, 10, 16]} />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default ClubhousePage
